module.exports = __webpack_public_path__ + "media/images/countryrect/am-1cb7be7f59ee371e2206b3ccd27ee063.svg";